'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalWrapper = function ModalWrapper(props) {
    var wrapperProps = Object.assign({}, props, { className: (0, _classnames2.default)('luna-modal__wrapper', [props.className]) });
    return _react2.default.createElement("div", Object.assign({}, wrapperProps), props.children);
};
exports.default = ModalWrapper;
//# sourceMappingURL=ModalWrapper.js.map


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/components/Modal/ModalWrapper.js